import { REACT_APP_OCA_BASE_URL } from '../config';

export function getPersonalOcaLink(dynamicsContactId: string) {
  const url = new URL(REACT_APP_OCA_BASE_URL);
  url.searchParams.set('vendorcontactId', dynamicsContactId);
  return url;
}

export function getLocationOcaLink(locationId: string, dynamicsAccountId: string) {
  const url = new URL(REACT_APP_OCA_BASE_URL);
  url.searchParams.set('vendorGUID', dynamicsAccountId);
  url.searchParams.set('locationId', locationId);
  return url;
}
